import { Result, Ok, Err } from 'ts-results'

// Function overload signatures
export async function tryCatch<T, E = Error>(promise: Promise<T>): Promise<Result<T, E>> {
	try {
		const data = await promise
		return Ok(data)
	} catch (error) {
		return Err(error as E)
	}
}

export function tryCatchSync<T, E = Error>(arg: () => T): Result<T, E> {
	try {
		const data = (arg as () => T)()
		return Ok(data)
	} catch (error) {
		return Err(error as E)
	}
}